import { ScheduleTopmost } from "routes/schedule/scheduleIntroduction"
import { FlagChecker } from "routes/schedule/plugins/flags/components/flag-checker"

ScheduleTopmost.plug(<FlagChecker $lazy />)
